import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';
import supabase from '../../lib/supabase';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user) {
        try {
          console.log("Checking admin status for user:", user.id);
          
          // Check if this is a mock admin user
          if (user.role === 'admin') {
            console.log("Mock admin user detected");
            setIsAdmin(true);
            setLoading(false);
            return;
          }
          
          const { data, error } = await supabase
            .from('profiles')
            .select('role')
            .eq('id', user.id)
            .single();
          
          if (error) {
            console.error("Error fetching profile:", error);
            throw error;
          }
          
          console.log("User profile data:", data);
          setIsAdmin(data?.role === 'admin');
        } catch (error) {
          console.error('Error checking admin status:', error);
          setIsAdmin(false);
        }
      }
      setLoading(false);
    };

    if (!authLoading) {
      checkAdminStatus();
    }
  }, [user, authLoading]);

  if (authLoading || loading) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  if (adminOnly) {
    if (!user) {
      console.log("No user, redirecting to admin login");
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    
    if (!isAdmin) {
      console.log("User is not admin, redirecting to admin login");
      return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }
    
    console.log("User is admin, allowing access");
  } else {
    if (!user) {
      console.log("No user, redirecting to login");
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;